module.exports = __webpack_public_path__ + "static/media/creative-commons-nc-eu.e1cc58f1.svg";